import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

import phonesHelper from "../helpers/phones";

export default {
  async create(data, accountId) {
    let payload = phonesHelper.buildCreateBody(data, accountId);

    try {
      return await HTTP.normal.post(`/phones`, payload);
    } catch (e) {
      throw "Não foi possivel criar o telefone!";
    }
  },

  async show(phoneId) {
    try {
      const response = await HTTP.normal.get(`/phones/${phoneId}`);

      return dataFormatter.deserialize(response.data);
    } catch (e) {
      throw "Não foi possivel buscar o telefone!";
    }
  },

  async getAccountPhones(accountId) {
    try {
      const response = await HTTP.normal.get(`/accounts/${accountId}/phones`);

      return dataFormatter.deserialize(response.data);
    } catch (e) {
      throw "Não foi possivel buscar os telefones da conta!";
    }
  },

  async delete(phoneId) {
    try {
      return await HTTP.normal.delete(`/phones/${phoneId}`);
    } catch (e) {
      throw "Não foi possivel deleter o telefone!";
    }
  },

  async update(data, phoneId) {
    let payload = phonesHelper.buildUpdateBody(data, phoneId);

    try {
      return await HTTP.normal.patch(`/phones/${phoneId}`, payload);
    } catch (e) {
      throw "Não foi possivel atualizar o telefone";
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/phones.js